<template>
  <div class="question-view img-drag" ref="questionView">
    <FixedFontSizeSelector class="fixedFontSizeSelector">
      <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">

        <div class="title">
          <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
        </div>

        <div class="img-show">
          <div v-drag-img="{self, className: '.block-style', idx}"
               :class="['single', existImage.includes(idx) && 'disabled', curClickSelectImage == idx && 'cur-select']"
               v-for="(item, idx) in imageList" :key="idx"
               @mousedown="clickEvent($event, idx)">
            <img :src="item.image" v-if="item.image" alt="">
          </div>
        </div>

      </div>
    </FixedFontSizeSelector>
    <div class="quest-img" :style="{backgroundImage: `url(${form.img_url})`}">
      <img :src="form.img_url" v-if="form.img_url" alt="">
    </div>
  </div>
</template>

<script>
import ImgDrag from './imgDrag/imgDrag';
import { _debounce } from '@/utils/throttle.js'
import {getNodeOffset} from '@/utils/scroll-to'
import FixedFontSizeSelector from '@/views/examination/components/dialog/FontSizeSelector'

let dragText = {
  bind(el, binding) {
    mobile(el, binding)
    pc(el, binding)
  }
}
function mobile(el, binding) {
  // 触摸开始
  el.addEventListener('touchstart', (e) => {
    e.stopPropagation();

    let { value } = binding,
        {className, self, idx} = value

    if(self.existImage.includes(idx)) {
      return
    }

    // ==================== 修复：三星平板 layerX/Y 失效 ====================
    const rect = el.getBoundingClientRect();
    const pageX = e.touches[0].pageX;
    const pageY = e.touches[0].pageY;
    const layerX = pageX - rect.left;
    const layerY = pageY - rect.top;

    let elPageX = pageX - layerX,
        elPageY = pageY - layerY,
        elWidth = el.offsetWidth,
        elHeight = el.offsetHeight

    let containers = document.querySelectorAll(className),
        containIdx = null,
        containArea = []

    for(let i = 0; i < containers.length; i++) {
      let container = containers[i],
          {left, top} = getNodeOffset(container),
          width = container.offsetWidth,
          height = container.offsetHeight,
          bottom = top + height,
          right = left + width
      containArea.push([left, top, right, bottom])
    }

    let copyEl = el.cloneNode(true)
    copyEl.style = `
      position: absolute;
      top: ${elPageY}px;
      left: ${elPageX}px;
      width: ${elWidth}px;
      height: ${elHeight}px;
      z-index: 9999;
    `
    let img = copyEl.querySelector('img')

    img && (img.style = `
      width: 100%;
      height: 100%;
      -o-object-fit: contain;
      object-fit: contain;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      -webkit-user-drag: none;
    `)

    document.body.append(copyEl)

    // 触摸移动
    const touchMoveHandler = (e) => {
      // ==================== 修复：三星平板必须阻止默认 ====================
      e.preventDefault();
      e.stopPropagation();

      const pageX = e.touches[0].pageX;
      const pageY = e.touches[0].pageY;
      const elPageX = pageX - layerX;
      const elPageY = pageY - layerY;

      copyEl.style.top = `${elPageY}px`
      copyEl.style.left = `${elPageX}px`

      containIdx = null;
      for(let i = 0; i < containArea.length; i++) {
        let item = containArea[i]
        if(pageX >= item[0] && pageY >= item[1] && pageX <= item[2] && pageY <= item[3]) {
          containIdx = i
          break;
        }
      }
    }

    // 触摸结束
    const touchEndHandler = () => {
      if(containIdx != null) {
        self.drag.assignment(containers[containIdx], idx, self)
      }
      document.body.removeChild(copyEl)

      document.body.removeEventListener('touchmove', touchMoveHandler);
      document.body.removeEventListener('touchend', touchEndHandler);
    }

    // ==================== 修复：三星平板必须 passive:false ====================
    document.body.addEventListener('touchmove', touchMoveHandler, { passive: false });
    document.body.addEventListener('touchend', touchEndHandler);

  }, { passive: false });
}
function pc(el, binding) {
  el.onmousedown = (e) => {
    let { value } = binding,
        {className, self, idx} = value

    if(self.existImage.includes(idx)) {
      return
    }

    let {layerX, layerY, pageX, pageY} = e,
        elPageX = pageX - layerX,
        elPageY = pageY - layerY,
        elWidth = el.offsetWidth,
        elHeight = el.offsetHeight

    let containers = document.querySelectorAll(className),
        containIdx = null,
        containArea = []

    for(let i = 0; i < containers.length; i++) {
      let container = containers[i]
      if(container.dataset.mislead == 'mislead') continue

      let {left, top} = getNodeOffset(container)
          , width = container.offsetWidth
          , height = container.offsetHeight
          , bottom = top + height
          , right = left + width
      containArea.push([left, top, right, bottom])
    }

    let copyEl = el.cloneNode(true)
    copyEl.style = `
      position: absolute;
      top: ${elPageY}px;
      left: ${elPageX}px;
      width: ${elWidth}px;
      height: ${elHeight}px;
      z-index: 9999;
    `
    let img = copyEl.querySelector('img')

    img && (img.style = `
      width: 100%;
      height: 100%;
      -o-object-fit: contain;
      object-fit: contain;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      -webkit-user-drag: none;
    `)

    document.body.append(copyEl)

    document.body.onmousemove = (e) => {
      pageX = e.pageX
      pageY = e.pageY
      elPageX = pageX - layerX
      elPageY = pageY - layerY

      copyEl.style.top = `${elPageY}px`
      copyEl.style.left = `${elPageX}px`

      for(let i = 0; i < containArea.length; i++) {
        let item = containArea[i]
        if(pageX >= item[0]
            && pageY >= item[1]
            && pageX <= item[2]
            && pageY <= item[3]) {
          containIdx = i
          break;
        } else {
          containIdx = null
        }
      }
    }

    document.body.onmouseup = () => {
      if(containIdx != null) {
        self.drag.assignment(containers[containIdx], idx, self)
      }
      document.body.removeChild(copyEl)
      document.body.onmouseup = null
      document.body.onmousemove = null
    }
  }
}

export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  directives: {
    'drag-img': dragText
  },
  data() {
    return {
      mathjaxNum: 0,
      image: '',
      topic: '',
      imageList: [],
      curClickSelectImage: null,
      existImage: [],
      emptyBlock: [],
      map: [],

      drag: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: {},
      self: this,
      limit: 0
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1
      if(i == num) {
        this.$parent.loading = false
      }
    },
    resetting() {
      this.$emit('permissions', false)
      this.limit = 0
      let blocks = document.querySelectorAll('.block-style')
      for(let i = 0; i < blocks.length; i++) {
        blocks[i].click()
      }

      this.recordQuestion = {}
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this, answers = {},
          blocks = document.querySelectorAll('.block-style')

      if(Object.keys(recordQuestion).length == 0) {
        return ;
      }

      this.limit = 1
      form.answers.map(its => {
        let [value] = JSON.parse(its.value)
        if(value) answers[its['choice_id']] = value.value
        else answers[its['choice_id']] = ''
      })

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
            id = block.dataset.id
        if(recordQuestion[id]) {
          block.style.backgroundImage = `url(${recordQuestion[id]})`

          this.imageList.filter((its, idx) => {
            if(its.image == recordQuestion[id]) {
              block.dataset.mark = idx.toString()
              this.existImage.push(Number(idx))
            }
          })
        }
      }

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
            id = block.dataset.id, url = ''
        if(block.style.backgroundImage) {
          let blockImg = block.style.backgroundImage.match(/"(.+?)"/g)[0]
          url = blockImg.substring(1, blockImg.length - 1)
        }

        if(this.mode == 'question') {
          continue ;
        }
        if(answers[id] == url) {
          block.classList.add('block-style-success')
        } else {
          block.classList.add('block-style-error')
        }
      }
    },
    addRegion() {
      this.drag.createBlock()
    },

    dragstart(e, idx) {
      e.dataTransfer.setData('info', idx)
    },
    clickEvent(e, idx) {
      if(!this.existImage.includes(idx))
        this.curClickSelectImage = idx
    },
    getNodeTotalHeight(dom) {
      if(!dom) return 0
      let styleData = window.getComputedStyle(dom, null)
      return dom.offsetHeight
          + Number(styleData.marginTop.replace('px', ''))
          + Number(styleData.marginBottom.replace('px', ''))
    },
    sizeEvent() {
      this.$nextTick(() => {
        let windowHeight = window.innerHeight,
            header = document.querySelector('.header'),
            mainHeight = document.querySelector('.main-header'),
            question = document.querySelector('.question-view'),
            quest = document.querySelector('.quest'),
            viewAnswer = document.querySelector('.viewAnswer-func')
        let imgDom = document.querySelector('.quest-img'),
            iWidth = question.clientWidth - 40 - quest.clientWidth,
            iHeight = windowHeight
                - this.getNodeTotalHeight(header)
                - this.getNodeTotalHeight(mainHeight)
                - this.getNodeTotalHeight(viewAnswer)
                - 40 - 30,
            imgBl = 833 / 500

        if(iWidth / imgBl <= iHeight) {
          iHeight = iWidth / imgBl
        }

        iHeight = iHeight > 500 ? 500 : iHeight
        iWidth = iWidth > 833 ? 833 : iWidth
        imgDom.style.height = iHeight + 'px'
        let bl = (iWidth / 833) * 500 / 300
        for(let i = 0; i < this.map.length; i++) {
          let {width, height, x, y, uuid} = this.map[i],
              block = document.querySelector(`#${uuid}`)
          if(!block) {
            continue ;
          }
          block.style.width = `${width * bl}px`
          block.style.height = `${height * bl}px`
          block.style.top = `${y * bl}px`
          block.style.left = `${x * bl}px`
        }
      })
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = {}
      this.existImage = []
      this.imageList = []

      this.drag = new ImgDrag({
        plate: '.quest-img',
        useType: 'view',
      })

      let content = JSON.parse(this.form.content)
      this.map = []
      for(let i = 0; i < this.form.choices.length; i++) {
        let its = this.form.choices[i],
            imgList = content.imageList[i]
        this.map.push({
          ...imgList,
          other: {
            id: its.id,
            position: its.position,
            type: its.type
          }
        })
      }
      content.imageList = content.imageList.filter(its => its.image && its)
      this.imageList = content.imageList
      for(let i = 0; i < this.imageList.length; i++) {
        let random = Math.floor(Math.random() * this.imageList.length)
        if(random != i) {
          [this.imageList[i], this.imageList[random]] = [this.imageList[random], this.imageList[i]]
        }
      }
      this.drag.echoBlock(this.map, this)
      setTimeout(() => this.showTrueFalse(), 500)
      this.sizeEvent()
    }
  },
  created() {

  },
  mounted() {
    this.initData()
    window.onresize = _debounce(this.sizeEvent, 500)
    if (!this.form.img_url) {
      document.documentElement.style.setProperty('--selector-width', '100%');
    } else {
      document.documentElement.style.setProperty('--selector-width', '50%');
    }
  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');
.fixedFontSizeSelector {
  width: var(--selector-width, 50%);
}

@media (max-width: 480px) {
  .fixedFontSizeSelector {
    width: var(--selector-width, 100%);
  }
}
.question-view {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;

  /* 核心：彻底禁止这个盒子里的下拉刷新 + 回弹 */
  overscroll-behavior: none;min-height: 0;

  .quest {
    flex: 1;
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }

    .img-show {
      width: 440px;
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      margin-top: 2px;
    }

    .single {
      position: relative;
      width: 100px;
      height: 100px;
      margin: 10px 10px 0 0;
      border-radius: 2px;
      box-shadow: 0 2px 3px 2px #ccc;
      overflow: hidden;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        user-select: none;
        -webkit-user-drag: none;
      }
    }

    .disabled {
      opacity: .4;
      cursor: not-allowed;
    }

    .cur-select {
      box-shadow: 0px 0px 10px 2px orange;
    }
  }
  .quest-img {
    margin-left: 10px;
    width: 833px;
    height: 500px;
    background-color: #fff;
    background-size: 100% 100%;
    position: relative;
    .img-region {
      position: relative;
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        position: absolute;
        background-color: #fff;
        color: #333;
      }

      &:after, &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -50%;
        margin: auto;
        height: 1px;
        width: 200%;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:before {
        transform: rotateZ(-45deg);
      }
    }

    img {
      width: 100%;
      height: 100%;
      user-select: none;
      -webkit-user-drag: none;
    }

  }
}
.quest .single {
  touch-action: none; /* 禁止系统手势冲突，三星必加 */
  -webkit-user-drag: none;
  user-select: none;
}
</style>